<template>
  <div ref="el">
    <div class="main-question">
      <contenteditable
        tag="p"
        :contenteditable="true"
        v-model="question"
        :noNL="true"
        @input="updateQuestion"
      />
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import contenteditable from "@/components/Contenteditable";

export default {
  mixins: [nodeMixin],
  components: {
    contenteditable,
  },
  data() {
    return {
      question: this.$t("action_plan.nodes.decision.config.question")
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    if (this.nodeData.data.config) {
      if (this.nodeData.data.config.question) {
        this.question = this.nodeData.data.config.question;
      }
    } else {
      this.nodeData.data.config = {};
      this.question = this.nodeData.data.config.question = this.$t(
        "action_plan.nodes.decision.config.question"
      );
      this.updateNodeConfig();
    }
  },
  methods: {
    updateQuestion(value) {
      this.question = value;
      this.updateNodeConfig();
    },
    updateNodeConfig() {
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      this.updateNodeData({
        config: { ...(currentNode.data.config || {}), question: this.question },
      });
    },
  },
};
</script>

<style></style>
